import { ArrowUp, Sparkles } from 'lucide-react';

export interface AskComposerProps {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  placeholder: string;
  disabled?: boolean;
  autoFocus?: boolean;
  showSend?: boolean;
  onFocus?: () => void;
}

export function AskComposer({
  value,
  onChange,
  onSubmit,
  placeholder,
  disabled = false,
  autoFocus = false,
  showSend = false,
  onFocus,
}: AskComposerProps) {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="flex items-center gap-2 rounded-lg border border-line-2 bg-bg px-3 py-2.5 focus-within:ring-2 focus-within:ring-brand focus-within:ring-offset-2 focus-within:ring-offset-canvas">
        <Sparkles className="h-4 w-4 shrink-0 text-t3" aria-hidden />
        <input
          autoFocus={autoFocus}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          placeholder={placeholder}
          aria-label="Ask Brainday"
          enterKeyHint="send"
          spellCheck={false}
          autoComplete="off"
          className="min-w-0 flex-1 bg-transparent text-body-lg text-t1 placeholder:text-t2 outline-none"
        />
        {showSend ? (
          <button
            type="submit"
            aria-label="Send"
            disabled={disabled || !value.trim()}
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand text-canvas outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas disabled:opacity-40 pointer-coarse:min-h-[44px] pointer-coarse:min-w-[44px]"
          >
            <ArrowUp className="h-4 w-4" aria-hidden />
          </button>
        ) : null}
      </div>
    </form>
  );
}
